import { EntityType } from '@frontend/common';
import { useLocale } from '@frontend/lang';
import { useBadgeRepository } from '@frontend/repository';

import { ObjectBadgeProps } from './object-badge.component';
import { BadgeUtils } from './utils/badge-utils';

/**
 * @deprecated For platform entity detail navigation use PlatformObjectBadge / openPlatformDetail instead.
 * Kept for admin and unmigrated callers; behavior unchanged.
 */
export const useObjectBadge = (props: ObjectBadgeProps) => {
    const { locale } = useLocale();
    const utils = new BadgeUtils(props.id || '', props.entityType, locale, props.display);

    const repository = useBadgeRepository({
        resolve: utils.resolve,
        type: props.entityType as EntityType,
        mapDisplayName: props.overwriteDisplayMap ?? utils.mapDisplayName,
        id: props.id,
        display: props.display,
        parentIds: props.parentIds
    });

    return {
        repository,
        utils
    };
};
